import { createRouter, createWebHistory } from 'vue-router';

import NotFound from '@lib/pages/NotFound.vue';

import external_routes from '@lib/router';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			component: () => import('@lib/layouts/Dashboard/Main.vue'),
			meta: { auth: true },
			children: [
				{ path: '/', name: 'Home', redirect: { name: 'Dashboard' } },
				{ path: '/my/dashboard', name: 'Dashboard', component: () => import('@/pages/Me/Dashboard.vue') },
				{ path: '/my/voicemail', name: 'My Voicemail', component: () => import('@/pages/Me/Voicemail.vue') },
				{ path: '/my/phonebook', name: 'My Phonebook', component: () => import('@/pages/Me/Phonebook.vue') },
				{
					path: '/my/call_history',
					name: 'My Call History',
					component: () => import('@/pages/Me/CallRecords.vue'),
				},
				{
					path: '/manage/:team_id/phones',
					name: 'Phones',
					component: () => import('@/pages/Manage/Phones.vue'),
				},
				{
					path: '/manage/:team_id/extensions',
					name: 'Extensions',
					component: () => import('@/pages/Manage/Extensions.vue'),
				},
				{
					path: '/manage/:team_id/ring_groups',
					name: 'Ring Groups',
					component: () => import('@/pages/Manage/RingGroups.vue'),
				},
				{
					path: '/manage/:team_id/shortcut_buttons',
					name: 'Shortcut Buttons',
					component: () => import('@/pages/Manage/ShortcutButtons.vue'),
				},
				{
					path: '/manage/:team_id/phonebook',
					name: 'Phonebook',
					component: () => import('@/pages/Manage/Phonebook.vue'),
				},
				{ path: '/admin/trunks', name: 'Trunks', component: () => import('@/pages/Admin/Trunks.vue') },
				{
					path: '/admin/call_records',
					name: 'Call Records',
					component: () => import('@/pages/Admin/CallRecords.vue'),
				},
				{
					path: '/admin/global_phonebook',
					name: 'Global Phonebook',
					component: () => import('@/pages/Manage/Phonebook.vue'),
				},
				{ path: '/admin/users', name: 'Users', component: () => import('@lib/pages/Admin/Users.vue') },
				{ path: '/admin/teams', name: 'Teams', component: () => import('@lib/pages/Admin/Teams.vue') },
				{ path: '/admin/teams/:team_id', component: () => import('@/pages/Admin/Teams/Settings.vue') },
				{
					path: '/admin/settings',
					name: 'Admin Settings',
					component: () => import('@/pages/Admin/Settings.vue'),
				},
				{ path: '/me', name: 'Profile', component: () => import('@/pages/Me/Me.vue') },
				// ...
				{
					path: ':pathMatch(.*)*',
					name: '404',
					component: NotFound,
				},
			],
		},
		...external_routes,
	],
});

export default router;
